import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import SvgIcon from "@Components/icons/SvgIcon";
import HomeLayout from '@Src/features/layout/components/HomeLayout/HomeLayout';
import { getAllBoardList, BoardData } from './services/AllBoards.service';
import './AllBoards.scss';
import moment from 'moment';

export const AllBoards = () => {
    const navigate = useNavigate();
    const [boards, setBoards] = useState<BoardData[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBoards = async () => {
            try {
                const response = await getAllBoardList();
                if (response.success) {
                    setBoards(response.data);
                }
            } catch (error) {
                console.error('Error fetching examinations:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchBoards();
    }, []);

    const handleExploreClick = (boardId: number, boardName: string) => {
        navigate(`/board/${boardId}/${boardName}`);
    };

    return (
        <HomeLayout>
            <section className="all-boards-container">
                <div className="ia-container mt-2">
                    <h2 className="ia-boardlist-heading tw-text-center mb-5">
                        All <span>Examinations</span>
                    </h2>

                    {loading ? (
                        <div className="ia-all-boards-grid">
                            {Array(8).fill(null).map((_, index) => (
                                <div key={index} className="ia-boardlist-card p-2">
                                    <Card className="custom-card h-full">
                                        <div className="tw-h-6 tw-bg-gray-200 tw-animate-pulse tw-rounded tw-mb-4 tw-w-1/2"></div>
                                        <div className="tw-h-20 tw-bg-gray-200 tw-animate-pulse tw-rounded tw-mb-4"></div>
                                        <div className="tw-h-8 tw-bg-gray-200 tw-animate-pulse tw-rounded tw-w-1/3"></div>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="ia-all-boards-grid">
                            {boards.map((board) => (
                                <div key={board.Id} className="ia-boardlist-card h-full">
                                    <Card className="custom-card h-full">
                                        <div>
                                            <div className='ia-boardlist-image text-center tw-flex tw-items-center tw-justify-center'>
                                                <img
                                                    src={board?.boardImageUrl || require("@Assets/img/no-img.jpg")}
                                                    alt={board.Name}
                                                    style={{ maxWidth: '100%',  maxHeight: '100%' }}
                                                    onError={(e: any) => { e.currentTarget.src = require("@Assets/img/no-img.jpg"); }}
                                                />
                                            </div>
                                            <div className="ia-boardlist-item tw-text-sm p-3">
                                                <div className='ia-boardlist-title '>{board.Name}</div>
                                                {board.RegistrationDate && (
                                                    <div className="ia-registration-date">Registration Date: <span className="ia-registration-date-value" style={{color:'#7a68e0'}}>{board?.RegistrationDate? moment(board.RegistrationDate).format("DD-MM-YYYY"):"-"}</span></div>
                                                )}
                                                <div className="ia-boardlist-content">
                                                    <p>{board.Description}</p>
                                                </div>
                                                <button
                                                    className="ia-btn ia-btn-text mt-3"
                                                    onClick={() => handleExploreClick(board.Id, board.Name)}
                                                >
                                                    Explore Now
                                                    <SvgIcon name="rightArrow" size={16} className="text-gray-600" />
                                                </button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </HomeLayout>
    );
};
